if (!customElements.get('uk-promo-slider')) {
  customElements.define('uk-promo-slider', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.track = this.querySelector('[data-track]');
      this.slides = [...this.track.children];
      this.prev = this.querySelector('[data-prev]');
      this.next = this.querySelector('[data-next]');
      this.count = this.querySelector('[data-count]');
      if (!this.prev || this.slides.length < 2) return;
      this.delay = this.classList.contains('uk-hero-slides') ? 7000 : 4000;
      this.motion = matchMedia('(prefers-reduced-motion: reduce)');
      this.paused = this.motion.matches;
      this.hovered = false;
      this.focused = false;
      this.controller = new AbortController();
      const opts = { signal: this.controller.signal };
      this.toggle = document.createElement('button');
      this.toggle.type = 'button';
      this.toggle.dataset.autoplayToggle = '';
      this.toggle.style.fontSize = '16px';
      this.toggle.style.pointerEvents = 'auto';
      this.next.before(this.toggle);
      if (this.classList.contains('uk-promos')) {
        Object.assign(this.toggle.style, { position: 'absolute', right: '44px' });
        this.querySelectorAll('.uk-promo-slide__inner').forEach(el => el.style.paddingRight = '92px');
      }
      this.count.setAttribute('aria-live', 'off');
      this.prev.addEventListener('click', () => { this.move(-1); this.schedule(); }, opts);
      this.next.addEventListener('click', () => { this.move(1); this.schedule(); }, opts);
      this.toggle.addEventListener('click', () => { this.paused = !this.paused; this.toggleLabel(); this.schedule(); }, opts);
      this.track.addEventListener('scroll', () => this.update(), opts);
      this.addEventListener('mouseenter', () => { this.hovered = true; this.schedule(); }, opts);
      this.addEventListener('mouseleave', () => { this.hovered = false; this.schedule(); }, opts);
      this.addEventListener('focusin', event => { this.focused = event.target !== this.toggle; this.schedule(); }, opts);
      this.addEventListener('focusout', event => { this.focused = this.contains(event.relatedTarget) && event.relatedTarget !== this.toggle; this.schedule(); }, opts);
      this.track.addEventListener('pointerdown', () => { this.interacting = true; this.schedule(); }, opts);
      window.addEventListener('pointerup', () => { if (this.interacting) { this.interacting = false; this.schedule(); } }, opts);
      window.addEventListener('pointercancel', () => { this.interacting = false; this.schedule(); }, opts);
      document.addEventListener('visibilitychange', () => this.schedule(), opts);
      this.motion.addEventListener('change', event => { if (event.matches) this.paused = true; this.toggleLabel(); this.schedule(); }, opts);
      this.update();
      this.toggleLabel();
      this.schedule();
    }
    move(direction) {
      if (!this.track.clientWidth) return;
      const current = Math.round(this.track.scrollLeft / this.track.clientWidth);
      const next = (current + direction + this.slides.length) % this.slides.length;
      this.track.scrollTo({ left: next * this.track.clientWidth, behavior: this.motion.matches ? 'instant' : 'smooth' });
    }
    update() {
      if (!this.track.clientWidth) return;
      const index = Math.round(this.track.scrollLeft / this.track.clientWidth);
      this.count.textContent = (index + 1) + ' / ' + this.slides.length;
      this.prev.disabled = false;
      this.next.disabled = false;
    }
    toggleLabel() {
      this.toggle.textContent = this.paused ? '▶' : 'Ⅱ';
      this.toggle.setAttribute('aria-label', this.paused ? 'Play slideshow' : 'Pause slideshow');
    }
    schedule() {
      clearTimeout(this.timer);
      if (this.paused || this.hovered || this.focused || this.interacting || document.hidden) return;
      this.timer = setTimeout(() => { this.move(1); this.schedule(); }, this.delay);
    }
    disconnectedCallback() {
      clearTimeout(this.timer);
      this.controller?.abort();
      this.toggle?.remove();
      this.ready = false;
    }
  });
}
if(!customElements.get('uk-deadline')){customElements.define('uk-deadline',class extends HTMLElement{connectedCallback(){this.end=Date.parse(this.dataset.deadline);if(!Number.isFinite(this.end))return;this.tick();this.timer=setInterval(()=>this.tick(),1000)}tick(){const ms=this.end-Date.now();if(ms<=0){this.hidden=true;const offer=this.closest(".uk-offer");if(offer)offer.hidden=true;clearInterval(this.timer);return}this.hidden=false;const total=Math.floor(ms/1000),days=Math.floor(total/86400),hours=Math.floor(total%86400/3600),minutes=Math.floor(total%3600/60),seconds=total%60;this.querySelector('[data-clock]').textContent=days+'d '+String(hours).padStart(2,'0')+'h '+String(minutes).padStart(2,'0')+'m '+String(seconds).padStart(2,'0')+'s'}disconnectedCallback(){clearInterval(this.timer)}})}
